import { baseApi } from "./baseApi";

import { reportTypeOptions, clientReportOptions, financeReportOptions,
  adminReportTypeOptions
 } from "../../constants/helperConstants";

export const downloadReport = (params: any, auth: any, isClient: any) => {
  return new Promise(function (resolve, reject) {
    const { report_type, start_date, end_date, brand_id, zone_id, brand_model_id, page_number } =
      params;
    let url = `reports/${report_type}.xlsx`;
    const options = isClient ? clientReportOptions : [...reportTypeOptions, ...financeReportOptions, ...adminReportTypeOptions
    ];
    // set query parameters
    url += "?";
    if (start_date) {
      url += `start_date=${start_date}&`;
    }
    if (end_date) {
      url += `end_date=${end_date}&`;
    }
    if (brand_id) {
      url += `brand_id=${brand_id}&`;
    }
    if (zone_id) {
      url += `zone_id=${zone_id}&`;
    }
    if (brand_model_id) {
      url += `brand_model_id=${brand_model_id}&`;
    }
    if (page_number) {
      url += `page_number=${page_number}&`;
    }

    // generating link with auth headers to download xlsx file
    const request = new XMLHttpRequest();

    request.open("GET", process.env.REACT_APP_SERVER_URL + "/api/v1/" + url, true);
    request.setRequestHeader("access-token", auth.accessToken);
    request.setRequestHeader("token-type", "Bearer");
    request.setRequestHeader("client", auth.client);
    request.setRequestHeader("uid", auth.uid);
    request.setRequestHeader("Content-Type", "application/json");

    // response type blob is required
    request.responseType = "blob";

    request.onload = function (e) {
      if (this.status >= 200 && this.status < 300) {
        if (this.status === 200) {
          const blob = this.response;

          // creating a downloadable link from blob
          const downloadLink = window.document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob([blob], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
          );
          downloadLink.download =
            options.filter((x) => x.value === report_type)[0].label +
            " " +
            start_date +
            " " +
            end_date;
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // remove recently appended anchor tag
          document.body.removeChild(downloadLink);
          resolve(request.response);
        }
        resolve(request.response);
      } else {
        try {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const resultText = reader.result ? reader.result.toString() : "{}";
              const errorData = JSON.parse(resultText);
              reject({ response: { data: errorData, status: this.status } });
            } catch {
              reject({ response: { data: { errors: "Unknown error" }, status: this.status } });
            }
          };
          reader.readAsText(this.response);
        } catch (e) {
          reject({ response: { data: { errors: "Server error" }, status: this.status } });
        }
      }
    };

    request.onerror = function () {
      reject(request.statusText);
    };

    request.send();
  });
};

const reportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fullReport: builder.mutation({
      query: (data) => ({
        url: "reports/full_report",
        method: "POST",
        body: data
      })
    }),
    refreshReportDownload: builder.mutation({
      query: (data) => ({
        url: "reports/refresh_report",
        method: "POST",
        body: data
      })
    }),
    emailReportRequest: builder.mutation({
      query: (data) => ({
        url: "reports/email_report_request",
        method: "POST",
        body: data
      })
    }),
    bulkCustomerReports: builder.mutation({
      query: ({ resource, ids }) => ({
        url: `${resource}/bulk_customer_reports`,
        method: "POST",
        body: { ids }
      })
    })
  })
});

export const {
  useFullReportMutation,
  useRefreshReportDownloadMutation,
  useEmailReportRequestMutation,
  useBulkCustomerReportsMutation
} = reportApi;
